__turbopack_context__.v({
  "green": "StrongerVariant-module__SsC4GG__green",
  "greenUnderline": "StrongerVariant-module__SsC4GG__greenUnderline",
  "outlineText": "StrongerVariant-module__SsC4GG__outlineText",
  "pink": "StrongerVariant-module__SsC4GG__pink",
  "sectionContainer": "StrongerVariant-module__SsC4GG__sectionContainer",
  "sectionText": "StrongerVariant-module__SsC4GG__sectionText",
  "underline": "StrongerVariant-module__SsC4GG__underline",
  "whiteOutlineText": "StrongerVariant-module__SsC4GG__whiteOutlineText",
  "whiteShadow": "StrongerVariant-module__SsC4GG__whiteShadow",
});
